import { useMutation, useQueryClient } from "@tanstack/react-query";

interface DocumentUploadProps {
  isFileValid: (file: File) => boolean;
}

export const useDocumentUpload = ({ isFileValid }: DocumentUploadProps) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ file, name }: { file: File; name: string }) => {
      isFileValid(file);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("name", name);

      const response = await fetch(`/api/profile-documents`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        let errorMessage = "Erreur lors de la mise en ligne du document";
        try {
          const errorData = await response.json();
          // Récupérer le message d'erreur du serveur
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch {
          // Si le body n'est pas du JSON valide, utiliser le statusText
          errorMessage = `${errorMessage}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();
      console.log("data", data);
      return data;
    },
    onSuccess: (_data) => {
      if (queryClient) {
        queryClient.invalidateQueries({
          queryKey: ["mon-profil", "documents"],
        });
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });
};
